import type { FC } from "react"
import { Navigate, Outlet, useLocation } from "react-router"
import { LoadingSpinner } from "@/components/LoadingSpinner"
import { useTenantAccess } from "@/lib/tenant-access"

export const TenantPermissionRoute: FC = () => {
  const location = useLocation()
  const { canManageTenant, isResolving } = useTenantAccess()

  if (isResolving) {
    return (
      <main className="h-screen flex items-center justify-center">
        <LoadingSpinner />
      </main>
    )
  }

  if (!canManageTenant) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />
  }

  return <Outlet />
}
